import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import { cerrarParte } from '../../api/client'
import { formatFecha } from '../unidades/tipos'
import { hoyLocal } from './fechas'

// "Cerrar parte": the closing date is confirmed by hand -- today offered,
// any day back to the opening allowed, never a later one.
export default function CerrarParteModal({ parte, onClose, onClosed }) {
  const { t } = useTranslation('engineering')
  const hoy = hoyLocal()
  const [fecha, setFecha] = useState(hoy)
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    if (!fecha) { setError(t('partes.cerrar.dateRequired')); return }
    if (fecha > hoy) { setError(t('partes.abrir.noFuture')); return }
    if (fecha < parte.fecha_apertura) { setError(t('partes.cerrar.beforeOpening', { fecha: formatFecha(parte.fecha_apertura) })); return }
    setSaving(true)
    setError('')
    try {
      onClosed(await cerrarParte(parte.id, fecha))
      onClose()
    } catch (err) {
      const d = err.response?.data?.detail
      setError(typeof d === 'string' ? `${t('partes.cerrar.failed')} (${d})` : t('partes.cerrar.failed'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal title={t('partes.cerrar.title', { numero: parte.numero })} onClose={onClose}>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-gray-600">
          <span className="font-medium text-gray-900">{parte.nombre}</span> · {parte.unidad_codigo}
          <span className="block text-xs text-gray-400 mt-0.5">{t('partes.cerrar.openedOn', { fecha: formatFecha(parte.fecha_apertura) })}</span>
        </p>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('partes.campos.fecha_cierre')} *</label>
          <input type="date" value={fecha} min={parte.fecha_apertura} max={hoy} onChange={e => setFecha(e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-200" />
          <p className="text-[11px] text-gray-400 mt-1">{t('partes.cerrar.dateHint')}</p>
        </div>
        {parte.implica_fs && parte.unidad_estado === 'Mantenimiento' && (
          <p className="text-xs rounded-lg bg-green-50 border border-green-200 text-green-800 px-3 py-2">
            {t('partes.fs.vuelveOperativo', { codigo: parte.unidad_codigo })}
          </p>
        )}
        {error && <p className="text-red-500 text-xs">{error}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose}
            className="bg-white border border-gray-200 text-gray-600 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors">
            {t('unidades.cancel')}
          </button>
          <button type="submit" disabled={saving}
            className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 disabled:opacity-40 transition-colors">
            {saving ? t('unidades.saving') : t('partes.cerrar.submit', { fecha: formatFecha(fecha) })}
          </button>
        </div>
      </form>
    </Modal>
  )
}
